import { render, staticRenderFns } from "./OrticDelete.vue?vue&type=template&id=7c9011b0&scoped=true&"
import script from "./OrticDelete.vue?vue&type=script&lang=js&"
export * from "./OrticDelete.vue?vue&type=script&lang=js&"
import style0 from "./OrticDelete.vue?vue&type=style&index=0&id=7c9011b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9011b0",
  null
  
)

export default component.exports